import { Backdrop, Box } from "@mui/material";
import { AIGif } from "@platformx/shared/static-assets";

export const AILoader = () => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open>
      <Box
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}>
        <Box
          sx={{
            width: "60px",
            height: "60px",
            padding: "10px",
            borderRadius: "7px",
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
          }}>
          <img src={AIGif} alt='Generating...' style={{ width: "40px" }} />
        </Box>
      </Box>
    </Backdrop>
  );
};
